import React from 'react';
import { useTranslation } from 'react-i18next';

// React-shared.
import { Select as SharedSelect } from '@exonet/react-shared/lib/Form';

const Select = (props) => {
  const { t } = useTranslation();

  return (
    <SharedSelect
      placeholder={t('core:select.placeholder')}
      noOptionsMessage={() => t('core:select.noOptionsFound')}
      {...props}
    />
  );
};

export default Select;
